// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__fP97n","title-container":"tooltip_title-container__0mk1x"};